<script lang="ts">
    import {getInjector} from 'src/core';
    import type {ToastMessage, ToastMessageTypeSettings, ToastType} from './types';
    import {ToastMessageService} from './toast-message.service';
    import {createEventDispatcher} from 'svelte';

    export let toast: ToastMessage;

    const toastMessageService = getInjector().getByClass(ToastMessageService);
    const dispatch = createEventDispatcher<{'toast-click': void}>();
    const toastSettings: Record<ToastType, ToastMessageTypeSettings> = {
        'info': {
            icon: 'info',
            backgroundColor: 'var(--body-bg)',
            borderColor: 'var(--border-default)',
            textColor: 'var(--text-default)'
        },
        'custom-component': {
            backgroundColor: 'var(--body-bg)',
            borderColor: 'var(--border-default)',
            textColor: 'var(--text-default)'
        },
        'success': {
            icon: 'check-circle',
            backgroundColor: 'var(--success-green)'
        },
        'error': {
            icon: 'cross-circle',
            backgroundColor: 'var(--danger-red)'
        },
        'warning': {
            icon: 'triangle-warning',
            backgroundColor: 'var(--warning-orange)'
        },
        'wait': {
            backgroundColor: 'var(--info-blue)'
        }
    };

    const settings = toastSettings[toast.type];

    const handleToastMessageDismiss = () => {
        toastMessageService.dismissToast(toast);
        dispatch('toast-click');
    };
</script>

<button class="toast-message-card"
        tabindex="-1"
        style:--bg-color={settings.backgroundColor}
        style:--text-color={settings.textColor ?? 'white'}
        style:--border-color={settings.borderColor ?? 'rgba(0, 0, 0, 0.2)'}
        on:click={handleToastMessageDismiss}>

    <slot icon={settings.icon}/>
</button>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .toast-message-card {
        padding: @spacing-m @spacing-ml;
        border-radius: @border-radius-default;
        display: flex;
        width: 100%;
        align-items: center;
        gap: @spacing-m;
        margin-bottom: @spacing-m;
        outline: none;
        cursor: pointer;
        background-color: var(--bg-color);
        border: 1px solid var(--border-color);
        color: var(--text-color);

        @media only screen and (max-width: @screen-xs-max) {
            padding: @spacing-s @spacing-m;
            margin-bottom: @spacing-s;
        }
    }
</style>